import React, { FunctionComponent } from 'react';
import styles from './BaseCardBody.module.scss';

interface IProps {
  children: React.ReactNode;
}

const BaseCardBody: FunctionComponent<IProps> = ({ children }) => <div className={styles.body}>{children}</div>;

export default BaseCardBody;
